import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FileInputComponent } from '../file-input/file-input.component';
@Component({
  selector: 'app-store-image-upload',
  templateUrl: './store-image-upload.component.html',
  styleUrls: ['./store-image-upload.component.scss'],
})
export class StoreImageUploadComponent implements OnInit {
  @Input() image: string;
  @Input() type: string;
  @Input() childMessage: string;
  @Input() title: string;
  @Output()
  upload: EventEmitter<File> = new EventEmitter<File>();

  @Output()
  uploadType: EventEmitter<boolean> = new EventEmitter<boolean>();

  fileData: File = null;
  previewUrl: any = null;
  @ViewChild('file') fileRef!: FileInputComponent;
  constructor() {}

  ngOnInit() {}

  onFileSelect(fileInput: any) {
    this.fileData = fileInput.target.files[0] as File;
    if (this.fileData) {
      this.preview();
    }
  }

  removeImage(e) {
    e.stopPropagation();
    this.uploadType.emit(false);
    this.clearImage();
  }

  removeLogo(e) {
    e.stopPropagation();
    this.uploadType.emit(true);
    this.clearImage();
  }

  private clearImage() {
    this.image = this.previewUrl = null;
    this.fileData = null;
    this.fileRef.clear();
  }

  preview() {
    const mimeType = this.fileData.type;
    const fileName = this.fileData.name.toLowerCase();

    // Check if file is HEIC/HEIF format
    const isHeic =
      fileName.endsWith('.heic') ||
      fileName.endsWith('.heif') ||
      mimeType === 'image/heic' ||
      mimeType === 'image/heif';

    if (isHeic) {
      // Browsers can't preview HEIC files natively
      // Skip local preview and let backend handle conversion
      // The image will be displayed after successful upload from backend URL
      this.previewUrl = null;
      return;
    }

    if (mimeType && !mimeType.match(/image\/*/)) {
      return;
    }

    const reader = new FileReader();
    reader.readAsDataURL(this.fileData);
    reader.onload = (event) => {
      this.previewUrl = reader.result;
    };
  }

  onSubmit() {
    if (this.fileData) {
      this.upload.emit(this.fileData);
      this.clearImage();
    }
  }
}
